import React from 'react';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { Button, Icon, Div, F } from 'components/Ui';
import { arrowBackward } from 'images';
import {
  selectDeliveryOrderIsFetching,
  selectSelectedServiceLocation,
} from '../selectors';
import doStyles from './delivery-order-styles.scss';

const SkipDeliveryOrderForm = ({ onClose, onSubmit, deliveryOrder }) => (
  <div className={doStyles.formWrapper}>
    <div className={doStyles.editForm}>
      <div className={doStyles.formHeader}>
        <Button
          className={doStyles.backButton}
          text="Back"
          icon={<img src={arrowBackward} alt="backward" />}
          onClick={onClose}
          iconPosition="left"
          link
        />
        <Icon icon="ban" />
        <h2>
          <F>You are skipping your</F> <br />
          <F>delivery on</F> {moment(deliveryOrder.date).format('MMMM D, YYYY')}
        </h2>
        <Div className={doStyles.subtext}>
          Future deliveries will follow your regular schedule.
        </Div>
      </div>
      <div className={doStyles.formBottom}>
        <div className={doStyles.formActions}>
          <Button
            className={doStyles.cancelButton}
            text="Cancel"
            onClick={onClose}
          />
          <Button
            className={doStyles.saveButton}
            text="Confirm"
            onClick={onSubmit}
          />
        </div>
      </div>
    </div>
  </div>
);

SkipDeliveryOrderForm.propTypes = {
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  deliveryOrder: PropTypes.object,
};

SkipDeliveryOrderForm.defaultProps = {};

const mapStateToProps = createStructuredSelector({
  isFetching: selectDeliveryOrderIsFetching(),
  serviceLocation: selectSelectedServiceLocation(),
});

export default withRouter(connect(mapStateToProps)(SkipDeliveryOrderForm));
